const SET_CURRENT_WEEK_SCHEDULE_ID = 'SET_CURRENT_WEEK_SCHEDULE_ID';
const GET_SCHEDULE_FOR_WEEK_REQUEST = 'GET_SCHEDULE_FOR_WEEK_REQUEST';
const GET_SCHEDULE_FOR_WEEK_SUCCESS = 'GET_SCHEDULE_FOR_WEEK_SUCCESS';
const GET_SCHEDULE_FOR_WEEK_FAILURE = 'GET_SCHEDULE_FOR_WEEK_FAILURE';
const CREATE_NEW_SCHEDULE_REQUEST = 'CREATE_NEW_SCHEDULE_REQUEST';
const CREATE_NEW_SCHEDULE_SUCCESS = 'CREATE_NEW_SCHEDULE_SUCCESS';
const CREATE_NEW_SCHEDULE_FAILURE = 'CREATE_NEW_SCHEDULE_FAILURE';
const SAVE_SHIFTS_TO_SCHEDULE_REQUEST = 'SAVE_SHIFTS_TO_SCHEDULE_REQUEST';
const SAVE_SHIFTS_TO_SCHEDULE_SUCCESS = 'SAVE_SHIFTS_TO_SCHEDULE_SUCCESS';
const SAVE_SHIFTS_TO_SCHEDULE_FAILURE = 'SAVE_SHIFTS_TO_SCHEDULE_FAILURE';
const PUBLISH_SCHEDULE_REQUEST = 'PUBLISH_SCHEDULE_REQUEST';
const PUBLISH_SCHEDULE_SUCCESS = 'PUBLISH_SCHEDULE_SUCCESS';
const PUBLISH_SCHEDULE_FAILURE = 'PUBLISH_SCHEDULE_FAILURE';
const UNPUBLISH_SCHEDULE_REQUEST = 'UNPUBLISH_SCHEDULE_REQUEST';
const UNPUBLISH_SCHEDULE_SUCCESS = 'UNPUBLISH_SCHEDULE_SUCCESS';
const UNPUBLISH_SCHEDULE_FAILURE = 'UNPUBLISH_SCHEDULE_FAILURE';
const SAVE_SHIFT_TO_WEEK_SCHEDULE = 'SAVE_SHIFT_TO_WEEK_SCHEDULE';
const EDIT_EXISTING_SHIFT = 'EDIT_EXISTING_SHIFT';
const REMOVE_SHIFTS_FROM_SCHEDULE = 'REMOVE_SHIFTS_FROM_SCHEDULE';
const COPY_SCHEDULE_TO_NEW_WEEK_REQUEST = 'COPY_SCHEDULE_TO_NEW_WEEK_REQUEST';
const COPY_SCHEDULE_TO_NEW_WEEK_SUCCESS = 'COPY_SCHEDULE_TO_NEW_WEEK_SUCCESS';
const COPY_SCHEDULE_TO_NEW_WEEK_FAILURE = 'COPY_SCHEDULE_TO_NEW_WEEK_FAILURE';
const COPY_SHIFT_TO_NEW_DATES_REQUEST = 'COPY_SHIFT_TO_NEW_DATES_REQUEST';
const COPY_SHIFT_TO_NEW_DATES_SUCCESS = 'COPY_SHIFT_TO_NEW_DATES_SUCCESS';
const COPY_SHIFT_TO_NEW_DATES_FAILURE = 'COPY_SHIFT_TO_NEW_DATES_FAILURE';

export default {
  SET_CURRENT_WEEK_SCHEDULE_ID,
  GET_SCHEDULE_FOR_WEEK_REQUEST,
  GET_SCHEDULE_FOR_WEEK_SUCCESS,
  GET_SCHEDULE_FOR_WEEK_FAILURE,
  CREATE_NEW_SCHEDULE_REQUEST,
  CREATE_NEW_SCHEDULE_SUCCESS,
  CREATE_NEW_SCHEDULE_FAILURE,
  SAVE_SHIFTS_TO_SCHEDULE_REQUEST,
  SAVE_SHIFTS_TO_SCHEDULE_SUCCESS,
  SAVE_SHIFTS_TO_SCHEDULE_FAILURE,
  PUBLISH_SCHEDULE_REQUEST,
  PUBLISH_SCHEDULE_SUCCESS,
  PUBLISH_SCHEDULE_FAILURE,
  UNPUBLISH_SCHEDULE_REQUEST,
  UNPUBLISH_SCHEDULE_SUCCESS,
  UNPUBLISH_SCHEDULE_FAILURE,
  SAVE_SHIFT_TO_WEEK_SCHEDULE,
  EDIT_EXISTING_SHIFT,
  REMOVE_SHIFTS_FROM_SCHEDULE,
  COPY_SCHEDULE_TO_NEW_WEEK_REQUEST,
  COPY_SCHEDULE_TO_NEW_WEEK_SUCCESS,
  COPY_SCHEDULE_TO_NEW_WEEK_FAILURE,
  COPY_SHIFT_TO_NEW_DATES_REQUEST,
  COPY_SHIFT_TO_NEW_DATES_SUCCESS,
  COPY_SHIFT_TO_NEW_DATES_FAILURE
};
